import { nanoid } from 'nanoid';
import { createAction, handleActions } from 'redux-actions';
import { delay, put, takeEvery } from 'redux-saga/effects';

export const actions = {
  create: createAction('notification.create', (notification) => ({
    id: nanoid(),
    timeout: 5000,
    ...notification,
  })),
  remove: createAction('notification.remove'),
};

export const reducer = handleActions(
  {
    [actions.create]: (s, { payload }) => [...s, payload],
    [actions.remove]: (s, { payload }) => s.filter((i) => i.id !== payload),
  },
  []
);

export const saga = [
  (function* () {
    yield takeEvery(actions.create, function* ({ payload }) {
      if (payload.permanent) return;
      yield delay(payload.timeout);
      yield put(actions.remove(payload.id));
    });
  })(),
];
